import React from 'react';

const Report = () => (
    <div className='w-100' style={{ height: '100vh'}}>
      <iframe
            src="http://52.90.3.245:3000/public/dashboard/7c928ed9-f2b5-467a-821b-d5a678de8d71"
            frameBorder="0"
            style={{ width: '100%', height: '100%', border: 'none' }}
            allowtransparency
            title='iframe'
          />
    </div>
);
  
export default Report;